import router from './router'
import store from './store'

router.beforeEach((to, from, next) => {
    // store.commit('SET_USERACCOUNTID', to.query.userAccountId)
    const query = to.query

    query.token && store.commit('changeToken', decodeURIComponent(query.token))

    query.id && store.commit('changeId', query.id)

    query.yudengji && store.commit('changePreReg', query.yudengji)

    query.exhibitorId && store.commit('changeExhibitorId', query.exhibitorId)

    query.subjectType && store.commit('changeSubjectType', query.subjectType)

    query.exhibitionId && store.commit('changeExhibitionId', query.exhibitionId)

    query.languageType && store.commit('changeLanguageType', query.languageType)

    query.appId && store.commit('changeAppID', query.appId)

    query.mobile && store.commit('changeMobile', query.mobile)

    query.terminal && store.commit('changeTerminal', query.terminal || 'wechat')

    query.theme && store.commit('changeThemeColor', '#' + query.theme)

    console.log(store.state.user, 'store.state.user')

    next()
})

router.afterEach((to) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
})
